import {
    ChangeDetectionStrategy,
    Component,
    ContentChildren,
    EventEmitter,
    Input,
    Output,
    QueryList
} from '@angular/core';
import { SimpleTabComponent } from '../simple-tab/simple-tab.component';
import { FormGroup } from '@angular/forms';

@Component({
    selector: 'app-simple-tabs',
    templateUrl: './simple-tabs.component.html',
    styleUrls: ['./simple-tabs.component.scss'],
    changeDetection: ChangeDetectionStrategy.Default,
    standalone: false
})
export class SimpleTabsComponent {
    private _tabs: QueryList<SimpleTabComponent>;
    public get tabs() {
        return this._tabs;
    }
    @ContentChildren(SimpleTabComponent) public set tabs(value: QueryList<SimpleTabComponent>) {
        this._tabs = value;
        this.lastTabIndex = this._tabs.length - 1;
        if (!this.tabIndex) {
            this.tabIndex = 0;
        }
    }
    @Output() public previous = new EventEmitter<boolean>();
    @Output() public next = new EventEmitter<boolean>();
    @Output() public cancelClick = new EventEmitter<void>();
    @Output() public save = new EventEmitter<void>();
    @Input() public loading = false;
    @Input() public form: FormGroup;
    @Input() public saveButtonLabelLanguageKey = 'BUTTONS.SAVE';
    public lastTabIndex: number;
    private _tabIndex: number;
    public get tabIndex() {
        return this._tabIndex;
    }
    @Input() public set tabIndex(value: number) {
        this._tabIndex = value;
        this._tabs?.map((tab, index) => (tab.active = this.tabIndex === index));
    }
}
